import Base from '@/resources/Base'

export default class Statistics extends Base {
  constructor (uuid = null, stats = [], attributes = {}, options = {}) {
    super(uuid, attributes, options)
    this.chartData = { labels: [], datasets: [] }
    this.statistics = stats
    this.buildChartData(stats)
  }

  getChartLabelProperties () {
    let labelCallback = this.labelCallback ? this.labelCallback : undefined
    let labelProp = this.labelProperty ? this.labelProperty : 'agentId'
    let labelVal = this.labelValue ? this.labelValue : 'count'
    return { callback: labelCallback, property: labelProp, value: labelVal }
  }

  /**
   * Method to convert server response into expected ChartJS data.
   *
   * vue-chartjs chart data expectation:
   *
   *  {
        labels: ['01:00', '02:00', '03:00', '04:00', '05:00', '06:00'],
        datasets: [
          {
            label: '2019-10-31',
            backgroundColor: '#f87979',
            data: [40, 20, 20, 10, 10, 15]
          }
        ]
      }
   *
   * API Response sample:
   *  [
        {
          "count": "211",
          "hour": 15
        },
        {
          "count": "3487",
          "hour": 16
        },
        {
          "count": "284",
          "hour": 17
        }
      ]
   */
  buildChartData (stats) {
    let chartProps = this.getChartLabelProperties()
    this.chartData.labels = _.map(stats, chartProps.property)
    this.chartData.datasets = [
      {
        label: !_.isEmpty(this.title) ? this.title : 'Count',
        backgroundColor: !_.isEmpty(this.backgroundColor) ? this.backgroundColor : '#fdbdca',
        borderColor: !_.isEmpty(this.borderColor) ? this.borderColor : '#ee3354',
        borderWidth: 1,
        data: _.map(stats, chartProps.value),
        stats: stats
      }
    ]
  }

  getChartOptions () {
    return this.chartOptions || {}
  }

  setChartClickEvent (clickFunction) {
    this.chartOptions['onClick'] = clickFunction
  }

  setLabelHostnames (hosts) {
    this.chartData.labels.forEach((label, idx) => {
      let hostnameIdx = _.findIndex(hosts, { agentId: label })
      // if agentId is found, use hostname instead for friendly labeling
      if (hostnameIdx > -1) {
        this.chartData.labels[idx] = hosts[hostnameIdx].customHostname
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/Statistics.js